import { FilterHandle } from '@access-erp/common';
import { MutableRefObject } from 'react';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { CONTRACTS_PER_PAGE } from '@/config/common.config';
import {
  BundleFilterInput,
  ContractLineGridFilterInput,
} from '@/graphql/contracts/_generated_/contracts';
import {
  GetPaginatedFilteredGridContractLines,
  GetPaginatedFilteredGridContractLinesVariables,
} from '@/graphql/contracts/_generated_/getPaginatedFilteredGridContractLines.query';
import GetPaginatedFilteredGridContractLinesQuery from 
  '@/graphql/contracts/getPaginatedFilteredGridContractLines.query.gql';
import { PaginatedFilteredGridData } from '@/utils/data-helpers/PaginatedFilteredGridData';

export type PaginatedFilteredGridContractLines =
  PaginatedFilteredGridData<ContractLineGridFilterInput>;

const useGetDetails = () => {
  const client = apolloClientContracts;

  return async (bundleId: string, filtersRef: MutableRefObject<FilterHandle>) => {
    const detailFilters: BundleFilterInput = (filtersRef.current?.applyToDetail
      ? filtersRef.current?.mappedDetailFilters
      : {}) as BundleFilterInput;
    const { data: contractLines, loading: loadingContractLines } = await client.query<
    GetPaginatedFilteredGridContractLines,
    GetPaginatedFilteredGridContractLinesVariables
    >({
      query: GetPaginatedFilteredGridContractLinesQuery,
      variables: {
        filter: { ...detailFilters, bundleId: { eq: bundleId } },
        first: CONTRACTS_PER_PAGE,
      },
      context: { important: true },
      fetchPolicy: 'network-only',
    });
    return {
      data: contractLines?.paginatedFilteredGridContractLines?.items ?? [],
      loading: loadingContractLines,
    };
  };
};

export default useGetDetails;
